import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import { useStore } from './store/useStore'
import Layout from './components/Layout'
import { SuspenseFallback } from './components/SuspenseFallback'
import { ErrorBoundary } from './components/ErrorBoundary'
import { NotificationContainer } from './components/Notification'
import { OfflineIndicator } from './components/OfflineIndicator'
import { InstallPrompt } from './components/InstallPrompt'
import { RTLWrapper } from './components/RTLWrapper'
import { ToastContainer } from './components/Toast'
import { useKeyboardNavigation } from './components/KeyboardNavigation'
import { usePerformance } from './hooks/usePerformance'
import { useSync } from './hooks/useSync'
import { useAnalytics } from './hooks/useAnalytics'

// 코드 스플리팅을 위한 lazy loading
const Dashboard = lazy(() => import('./pages/Dashboard'))
const Predictions = lazy(() => import('./pages/Predictions'))
const Risk = lazy(() => import('./pages/Risk'))
const Actions = lazy(() => import('./pages/Actions'))
const Intelligence = lazy(() => import('./pages/Intelligence'))
const Stability = lazy(() => import('./pages/Stability'))
const KPI = lazy(() => import('./pages/KPI'))
const Wholesale = lazy(() => import('./pages/Wholesale'))
const TimeSeries = lazy(() => import('./pages/TimeSeries'))
const Exchange = lazy(() => import('./pages/Exchange'))
const Financial = lazy(() => import('./pages/Financial'))
const Personalization = lazy(() => import('./pages/Personalization'))
const MarketAdmin = lazy(() => import('./pages/MarketAdmin'))
const Partner = lazy(() => import('./pages/Partner'))
const Voice = lazy(() => import('./pages/Voice'))
const Settings = lazy(() => import('./pages/Settings'))
const History = lazy(() => import('./pages/History'))

function AppContent() {
  useKeyboardNavigation()
  usePerformance()
  useSync({ interval: 60000 }) // 1분마다 동기화
  useAnalytics()

  return (
    <>
      <OfflineIndicator />
      <InstallPrompt />
      <NotificationContainer />
      <ToastContainer />
      <Layout>
        <Suspense fallback={<SuspenseFallback />}>
          <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/predictions" element={<Predictions />} />
              <Route path="/risk" element={<Risk />} />
              <Route path="/actions" element={<Actions />} />
              <Route path="/intelligence" element={<Intelligence />} />
              <Route path="/stability" element={<Stability />} />
              <Route path="/kpi" element={<KPI />} />
              <Route path="/wholesale" element={<Wholesale />} />
              <Route path="/timeseries" element={<TimeSeries />} />
              <Route path="/exchange" element={<Exchange />} />
              <Route path="/financial" element={<Financial />} />
              <Route path="/personalization" element={<Personalization />} />
              <Route path="/market-admin" element={<MarketAdmin />} />
              <Route path="/partner" element={<Partner />} />
          <Route path="/voice" element={<Voice />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/history" element={<History />} />
          <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
      </Layout>
    </>
  )
}

function App() {
  const user = useStore((state) => state.user)
  const language = user?.language || 'ko'

  return (
    <ErrorBoundary>
      <RTLWrapper language={language}>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </RTLWrapper>
    </ErrorBoundary>
  )
}

export default App

